import React, { useEffect, useState } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { IonApp, setupIonicReact } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
/* Using default light theme - no dark palette import needed */

import { Home, Landing, Launch, FindTripAsRider, ViewResultAsRider, PastTrips, UpcomingTrips, PendingTrips } from "../src";
import Profile from './components/Profile/Profile';
import StartTrip from './components/StartTrip/StartTrip';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

setupIonicReact();

const App = () => {
  const [user, setUser] = useState({});

  useEffect(() => {
    const theUser = localStorage.getItem("user");
    if (theUser && !theUser.includes("undefined")) {
      setUser(JSON.parse(theUser));
    }
  }, []);

  return (
    <IonApp>
      <ErrorBoundary>
        <HashRouter>
          <Routes>
            <Route
              path="/"
              element={user?.email ? <Navigate to="/home" replace /> : <Landing />}
            />
            <Route
              path="/home"
              element={user?.email ? <Home user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/launch"
              element={user?.email ? <Launch user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/profile"
              element={user?.email ? <Profile user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/starttrip"
              element={user?.email ? <StartTrip user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/findtripasrider"
              element={user?.email ? <FindTripAsRider user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/viewresultasrider"
              element={user?.email ? <ViewResultAsRider user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/pasttrips"
              element={user?.email ? <PastTrips user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/upcomingtrips"
              element={user?.email ? <UpcomingTrips user={user} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/pendingtrips"
              element={user?.email ? <PendingTrips user={user} /> : <Navigate to="/" replace />}
            />
          </Routes>
        </HashRouter>
      </ErrorBoundary>
    </IonApp>
  );
}

export default App;
